module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_01_Title.f499033d.png";